var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCardIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1455_6836)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 24.648C3.837 24.648 3.201 24.385 2.732 23.916C2.263 23.447 2 22.811 2 22.148V10.1479C2 9.48495 2.263 8.84895 2.732 8.37995C3.201 7.91195 3.837 7.64795 4.5 7.64795C7.89 7.64795 20.11 7.64795 23.5 7.64795C24.163 7.64795 24.799 7.91195 25.268 8.37995C25.737 8.84895 26 9.48495 26 10.1479V22.148C26 22.811 25.737 23.447 25.268 23.916C24.799 24.385 24.163 24.648 23.5 24.648H11.989C11.789 24.648 11.608 24.767 11.53 24.951L10.027 28.457C9.694 29.235 8.907 29.719 8.062 29.665C7.218 29.611 6.498 29.032 6.266 28.218L5.349 25.011C5.288 24.7959 5.092 24.648 4.869 24.648H4.5Z",
    fill: "url(#paint0_linear_1455_6836)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 21.6592H11C11.552 21.6592 12 21.2102 12 20.6592C12 20.1072 11.552 19.6592 11 19.6592H7C6.448 19.6592 6 20.1072 6 20.6592C6 21.2102 6.448 21.6592 7 21.6592ZM7 17.6592H21C21.552 17.6592 22 17.2102 22 16.6592C22 16.1072 21.552 15.6592 21 15.6592H7C6.448 15.6592 6 16.1072 6 16.6592C6 17.2102 6.448 17.6592 7 17.6592ZM7 13.6592H21C21.552 13.6592 22 13.2102 22 12.6592C22 12.1072 21.552 11.6592 21 11.6592H7C6.448 11.6592 6 12.1072 6 12.6592C6 13.2102 6.448 13.6592 7 13.6592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.783 7.69314C15.326 7.79414 15 8.20014 15 8.66914C15 9.13814 15.326 9.54414 15.783 9.64513L24 11.4711V12.6691C24 13.0731 24.244 13.4381 24.617 13.5931C24.991 13.7481 25.421 13.6621 25.707 13.3761L29.707 9.37613C30.098 8.98614 30.098 8.35214 29.707 7.96214L25.707 3.96213C25.421 3.67613 24.991 3.59013 24.617 3.74513C24.244 3.90013 24 4.26513 24 4.66913V5.86713L15.783 7.69314Z",
    fill: "url(#paint1_linear_1455_6836)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_6836",
    x1: 2.66667,
    y1: 8.66878,
    x2: 26.6667,
    y2: 24.6688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EC0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244AD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_6836",
    x1: 20,
    y1: 4.00228,
    x2: 28,
    y2: 12.6689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DE161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CB53E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1455_6836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.668945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCardIcon4);
export default __webpack_public_path__ + "static/media/message_card_icon4.64808d64adbabafdedbf6b651b81f085.svg";
export { ForwardRef as ReactComponent };